export const BASE_URL = 'https://goodwill-connect.com/goodwillconnect'
//export const BASE_URL = 'http://20.81.144.246:8081'
//export const BASE_URL = 'http://localhost:5091'
export const HOME_URL = '/api/v2/goodwillconnect'
export const STATE_URL = '/api/state'
export const CAREER_NAVIGATOR_URL = '/api/contactus'
export const TIME_OUT = 1000 * 270
export const COMMON_ERROR = 'Something went wrong!!'